module.exports = __webpack_public_path__ + "img/SES_280140025.dc2fe1eb.jpg";